export const INSTAGRAM_VIDEO_LIST_REQUEST =
  "INSTAGRAM_VIDEO_LIST_REQUEST";

export const INSTAGRAM_VIDEO_LIST_SUCCESS =
  "INSTAGRAM_VIDEO_LIST_SUCCESS";

export const INSTAGRAM_VIDEO_LIST_FAIL =
  "INSTAGRAM_VIDEO_LIST_FAIL";